import { __assign, __extends } from "tslib";
import { Base } from '@antv/g-base';
import { deepMix, each, hasKey, isObject } from '@antv/util';
var LOCATION_FIELD_MAP = {
    none: [],
    point: ['x', 'y'],
    region: ['start', 'end'],
    points: ['points'],
    circle: ['center', 'radius', 'startAngle', 'endAngle'],
};
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.initCfg();
        return _this;
    }
    /**
     * @protected
     * é»è®¤çéç½®é¡¹
     * @returns {object} é»è®¤çéç½®é¡¹
     */
    Component.prototype.getDefaultCfg = function () {
        return {
            id: '',
            name: '',
            type: '',
            locationType: 'none',
            offsetX: 0,
            offsetY: 0,
            animate: false,
            capture: true,
            updateAutoRender: false,
            animateOption: {
                appear: null,
                update: {
                    duration: 400,
                    easing: 'easeQuadInOut',
                },
                enter: {
                    duration: 400,
                    easing: 'easeQuadInOut',
                },
                leave: {
                    duration: 350,
                    easing: 'easeQuadIn',
                },
            },
            events: null,
            defaultCfg: {},
            visible: true,
        };
    };
    /**
     * æ¸çç»ä»¶çåå®¹ï¼ä¸è¬éå render ä½¿ç¨
     * @example
     * axis.clear();
     * axis.render();
     */
    Component.prototype.clear = function () { };
    /**
     * æ´æ°ç»ä»¶
     * @param {object} cfg æ´æ°å±æ§
     */
    Component.prototype.update = function (cfg) {
        var _this = this;
        var defaultCfg = this.get('defaultCfg') || {};
        each(cfg, function (value, name) {
            var originCfg = _this.get(name);
            var newCfg = value;
            if (originCfg !== value) {
                // å¤æ­ä¸¤èæ¯å¦ç¸ç­ï¼ä¸»è¦æ¯è¿è¡ null çå¤å®
                if (isObject(value) && defaultCfg[name]) {
                    // æ°è®¾ç½®çå±æ§ä¸é»è®¤å¼è¿è¡åå¹¶
                    newCfg = deepMix({}, defaultCfg[name], value);
                }
                _this.set(name, newCfg);
            }
        });
        this.updateInner(cfg);
        this.afterUpdate(cfg);
    };
    // æ´æ°åé¨
    Component.prototype.updateInner = function (cfg) {
    };
    Component.prototype.afterUpdate = function (cfg) {
        // æ´æ°æ¶èèæ¾ç¤ºãéè
        if (hasKey(cfg, 'visible')) {
            if (cfg.visible) {
                this.show();
            }
            else {
                this.hide();
            }
        }
        // æ´æ°æ¶èècapture
        if (hasKey(cfg, 'capture')) {
            this.setCapture(cfg.capture);
        }
    };
    Component.prototype.getLayoutBBox = function () {
        return this.getBBox(); // é»è®¤è¿å getBBoxï¼ä¸åçç»ä»¶åé¨åç¬å®ç°
    };
    Component.prototype.getLocationType = function () {
        return this.get('locationType');
    };
    Component.prototype.getOffset = function () {
        return {
            offsetX: this.get('offsetX'),
            offsetY: this.get('offsetY'),
        };
    };
    // é»è®¤ä½¿ç¨ update
    Component.prototype.setOffset = function (offsetX, offsetY) {
        this.update({
            offsetX: offsetX,
            offsetY: offsetY,
        });
    };
    Component.prototype.setLocation = function (cfg) {
        var location = __assign({}, cfg);
        this.update(location);
    };
    // å®ç° ILocation æ¥å£ç getLocation
    Component.prototype.getLocation = function () {
        var _this = this;
        var location = {};
        var locationType = this.get('locationType');
        var fields = LOCATION_FIELD_MAP[locationType];
        each(fields, function (field) {
            location[field] = _this.get(field);
        });
        return location;
    };
    Component.prototype.isList = function () {
        return false;
    };
    Component.prototype.isSlider = function () {
        return false;
    };
    /**
     * @protected
     * åå§åï¼ç¨äºå·ä½çç»ä»¶ç»§æ¿
     */
    Component.prototype.init = function () { };
    // å°ç»ä»¶é»è®¤çéç½®é¡¹è®¾ç½®åå¹¶å°ä¼ å¥çéç½®é¡¹
    Component.prototype.initCfg = function () {
        var _this = this;
        var defaultCfg = this.get('defaultCfg');
        each(defaultCfg, function (value, name) {
            var cfg = _this.get(name);
            if (isObject(cfg)) {
                var newCfg = deepMix({}, value, cfg);
                _this.set(name, newCfg);
            }
        });
    };
    return Component;
}(Base));
export default Component;
//# sourceMappingURL=component.js.map